import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../_services/notification.service';
import { TokenService } from '../_services/token.service';
import { HeaderService } from '../_services/header.service';
import { FirebaseAuthService } from '../_services/firebase-auth.service';
import { UsersService } from '../_services/users.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  private readonly ICONS_PATH = '../../assets/icons';

  @Input()
  title:string = '';

  status: boolean = false;

  nomeAgencia: string = 'deslogado';
  logo!: string;

  isTrial: boolean = false;
  dateTrial!: Date;

  listMenu: any[] = [];

  profileCode!: string;
  userName!: string;
  hasAddDriverPermission: boolean = false;

  notifications: any[] = [];

  get bellColor(): string {
    return this.notifications.length > 0 ? '#FF9900' : '#FFFFFF';
  }

  sidebarVisible: boolean = true;

  get isSubclient(): boolean {
    return this.tokenService.profileCode === 'SUBCLIENTE';
  };

  get canManageDrivers(): boolean {
    return this.profileCode === 'ADMIN' || this.profileCode === 'SUPORTE' || this.hasAddDriverPermission;
  }

  constructor(
    private tokenService: TokenService,
    private notificationService: NotificationService,
    private firebaseAuthService: FirebaseAuthService,
    private headerService: HeaderService,
    private router: Router,
    private usersService: UsersService
  ) {
  }

  isMobile = false;

  ngOnInit(): void {
   
    this.nomeAgencia = 'Carreteiro';

    this.profileCode = this.tokenService.profileCode;
    this.hasAddDriverPermission = this.tokenService.addDriver;

    this.headerService.titleObservable.subscribe(res =>{
      this.title = res;
    });  

    this.userName = this.tokenService.name;

    this.bindMenu();
    this.loadLoggedUserPermissions();

    this.firebaseAuthService.user$.subscribe((user) => {
      if (user) {
        this.notificationService.init();
  
        this.notificationService.getNotifications().subscribe((notifs) => {
          this.notifications = notifs;
        });
      }
    });
  }

  clickEvent() {
    this.status = !this.status;
  }

  toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
  }

  bindMenu() {
    this.listMenu = [];

    if (this.profileCode == 'ADMIN' || this.profileCode == 'GESTOR') {
      this.listMenu.push({ 
        routerLink: '/notification', 
        ico: `${this.ICONS_PATH}/bell.svg`, 
        label: 'Notificações' 
      });
    }
      
    this.listMenu.push({ 
      routerLink: '/', 
      ico: `${this.ICONS_PATH}/home.svg`, 
      label: 'Página inicial' 
    });

    if (this.profileCode == 'ADMIN' || this.profileCode == 'GESTOR' ||
      this.profileCode == 'CLIENTE') {
      this.listMenu.push({ 
        routerLink: '/travel-map', 
        ico: `${this.ICONS_PATH}/location.svg`,  
        label: 'Viagens em Andamento' 
      });
      
      this.listMenu.push({ 
        routerLink: '/travels/Finished', 
        ico: `${this.ICONS_PATH}/truck.svg`, 
        label: 'Histórico de Viagens' 
      });
    }
    
    if (this.profileCode == 'ADMIN' ) {
      this.listMenu.push({ 
        routerLink: '/users', 
        ico: `${this.ICONS_PATH}/people.svg`, 
        label: 'Usuários e Grupos' 
      });
    }

    if (this.profileCode == 'CLIENTE') {
      this.listMenu.push({ 
        routerLink: '/users', 
        ico: `${this.ICONS_PATH}/people.svg`, 
        label: 'Clientes cadastrados' 
      });
    }
    
    if (this.profileCode == 'ADMIN' || this.profileCode == 'GESTOR') {
      this.listMenu.push({ 
        routerLink: '/tasks', 
        ico: `${this.ICONS_PATH}/magnifier.svg`, 
        label: 'Pendências' 
      });
    }
    
    if (this.profileCode == 'ADMIN' || this.profileCode == 'GESTOR'
    ) {
      this.listMenu.push({ 
        routerLink: '/checklist', 
        ico: `${this.ICONS_PATH}/check-square.svg`, 
        label: 'Checklist' 
      });
    }
    
    if (this.canManageDrivers) {
      this.listMenu.push({ 
        routerLink: '/drivers', 
        ico: `${this.ICONS_PATH}/file-person.svg`, 
        label: 'Motoristas' 
      });
    }
    
    if (this.profileCode == 'CLIENTE' || this.profileCode === 'ADMIN') {
      this.listMenu.push({ 
        routerLink: '/shared', 
        ico: `${this.ICONS_PATH}/truck-share.svg`, 
        label: 'Viagens Compartilhadas' 
      });
    }
    
    if (this.profileCode == 'ADMIN') {
      this.listMenu.push({ 
        routerLink: '/kmm', 
        ico: `${this.ICONS_PATH}/monitor-data.svg`, 
        label: 'Dados KMM' 
      });
    }

    if (this.profileCode == 'ADMIN' || this.profileCode == 'GESTOR' ||
      this.profileCode == 'CLIENTE') {
      this.listMenu.push({ 
        routerLink: '/terms', 
        ico: `${this.ICONS_PATH}/shield-check.svg`, 
        label: 'Termos e Política de Privacidade' 
      });
    }

    if (this.profileCode == 'ADMIN') {
      this.listMenu.push({ 
        routerLink: '/messages', 
        ico: `${this.ICONS_PATH}/send.svg`, 
        label: 'Mensagens' 
      });
    }

    if (this.profileCode == 'GESTOR' || this.profileCode === 'ADMIN') {
      this.listMenu.push({ 
        routerLink: '/treinamento', 
        ico: `${this.ICONS_PATH}/treinamento.svg`, 
        label: 'Treinamento' 
      });
    }

    if (this.profileCode === 'ADMIN') {
      this.listMenu.push({ 
        routerLink: '/feedback', 
        ico: `${this.ICONS_PATH}/feedback.svg`, 
        label: 'Avaliações' 
      });
      this.listMenu.push({
        routerLink: '/logs',
        ico: `${this.ICONS_PATH}/monitor-data.svg`,
        label: 'Logs'
      });
      // this.listMenu.push({
      //   routerLink: '/lacre',
      //   ico: `${this.ICONS_PATH}/lacre.svg`,
      //   label: 'Lacres'
      // });
    }

    if (this.profileCode === 'ADMIN' || this.profileCode === 'SUPORTE') {
      this.listMenu.push({
        routerLink: '/support',
        ico: `${this.ICONS_PATH}/life-buoy.svg`,
        label: 'Suporte'
      });
    }


    // if (this.profileCode == 'ADMIN' ||
    //   this.profileCode == 'GESTOR' ||
    //   ) {
    //   this.listMenu.push({ routerLink: '/notify', ico: 'bi-send', label: 'Notificar viagem' });
    // }

    // if (this.profileCode == 'ADMIN') {
    //   this.listMenu.push({ routerLink: '/route', ico: 'bi-map-fill', label: 'Rotas' });
    // }

    // if (this.profileCode == 'ADMIN') {
    //   this.listMenu.push({ routerLink: '/rescue', ico: 'bi-currency-dollar', label: 'Resgates' });
    // }

    // if (this.profileCode == 'ADMIN' ||
    //   this.profileCode == 'GESTOR' ||
    //   ) {
    //   this.listMenu.push({ routerLink: '/freight', ico: 'bi-truck', label: 'Fretes' });
    // }
  }

  private loadLoggedUserPermissions() {
    if (this.canManageDrivers) return;

    this.usersService.getUserId(this.tokenService.id).subscribe({
      next: user => {
        const hasAddDriver = this.toBoolean(user?.addDriver ?? user?.AddDriver);

        if (hasAddDriver !== this.hasAddDriverPermission) {
          this.hasAddDriverPermission = hasAddDriver;
          this.bindMenu();
        }
      },
      error: err => console.log(err)
    });
  }

  private toBoolean(value: any): boolean {
    return value === true || value === 'true' || value === 'True' || value === 1 || value === '1';
  }

  logout() {
    this.tokenService.logout();
    this.router.navigate(['/login']);
  }

  isDefaultHomePage() {
    return this.router.url === '/' && 
      this.tokenService.profileCode !== 'SUBCLIENTE';
  }
}
